import React, { useRef, useState } from "react";
import { Search } from "lucide-react";

// Image avec zoom au survol : la photo s'agrandit et suit le curseur.
export const ZoomImage = ({ src, alt, className = "", zoom = 2, testId, showHint = false }) => {
  const ref = useRef(null);
  const [origin, setOrigin] = useState("50% 50%");
  const [active, setActive] = useState(false);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const point = e.touches && e.touches[0] ? e.touches[0] : e;
    const x = ((point.clientX - rect.left) / rect.width) * 100;
    const y = ((point.clientY - rect.top) / rect.height) * 100;
    setOrigin(`${Math.max(0, Math.min(100, x))}% ${Math.max(0, Math.min(100, y))}%`);
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      className={`relative overflow-hidden cursor-zoom-in ${className}`}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      onMouseMove={handleMove}
      onTouchStart={(e) => { setActive(true); handleMove(e); }}
      onTouchMove={handleMove}
      onTouchEnd={() => setActive(false)}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition-transform duration-200 ease-out will-change-transform"
        style={{ transform: active ? `scale(${zoom})` : "scale(1)", transformOrigin: origin }}
      />
      {showHint && (
        <span
          className={`absolute bottom-3 right-3 inline-flex items-center gap-1.5 bg-white/85 backdrop-blur text-[var(--oz-text)] text-[11px] font-semibold px-2.5 py-1 rounded-full shadow-sm transition-opacity duration-200 ${
            active ? "opacity-0" : "opacity-100"
          }`}
        >
          <Search className="w-3 h-3" /> Survolez pour zoomer
        </span>
      )}
    </div>
  );
};

export default ZoomImage;
